import React from 'react';
import { withRouter } from 'react-router-dom';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import AddBikeForm from '../../components/Bike/AddBikeForm';
import withAuthorization from '../../hoc/withAuthorization';

const AddBikePage = props =>
    <LargePaper>
        <h1 style={stylesDefault.title}>Ajouter un vélo</h1>
        <AddBikeForm history={props.history}/>
    </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(AddBikePage));



// WEBPACK FOOTER //
// ./src/containers/BikesPage/AddBikePage.jsx